import { getMaveshiDesignToken, getSidebarSurfaceColors, getSidebarVariant } from './maveshiTheme';

const SYNC_TOKEN_KEYS = [
  'colorPrimary',
  'colorPrimaryHover',
  'colorPrimaryActive',
  'colorPrimaryBg',
  'colorPrimaryBgHover',
  'colorPrimaryBorder',
  'colorPrimaryBorderHover',
  'colorBgLayout',
  'colorBgContainer',
  'colorBgElevated',
  'colorText',
  'colorTextSecondary',
  'colorTextTertiary',
  'colorBorder',
  'colorBorderSecondary',
  'colorLink',
  'colorInfo',
  'colorSuccess',
];

function toCssVarName(tokenKey) {
  return `--maveshi-${tokenKey.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()}`;
}

/** Push resolved Ant Design tokens onto :root for custom CSS + legacy overrides. */
export function syncMaveshiCssVars(themeMode, isCompact, colorScheme, isMobileComfort = false) {
  const tokens = getMaveshiDesignToken(themeMode, isCompact, colorScheme, isMobileComfort);
  const root = document.documentElement;

  SYNC_TOKEN_KEYS.forEach((key) => {
    const value = tokens[key];
    if (value !== undefined && value !== null) {
      root.style.setProperty(toCssVarName(key), value);
    }
  });

  const sidebarSurface = getSidebarSurfaceColors(colorScheme);

  root.style.setProperty('--header-accent', tokens.colorPrimary);
  root.style.setProperty('--sidebar-accent', tokens.colorPrimary);
  root.style.setProperty('--sidebar-accent-soft', sidebarSurface.menuSelectedBg);
  root.style.setProperty('--sidebar-accent-hover', sidebarSurface.menuSelectedBgHover);
  root.style.setProperty('--sidebar-bg', sidebarSurface.bg);
  root.style.setProperty('--sidebar-bg-elevated', sidebarSurface.bgElevated);
  root.style.setProperty('--sidebar-bg-deep', sidebarSurface.bgDeep);
  root.style.setProperty('--sidebar-border', sidebarSurface.border);
  root.style.setProperty('--sidebar-control-bg', sidebarSurface.controlBg);
  root.style.setProperty('--sidebar-control-bg-hover', sidebarSurface.controlBgHover);
  root.style.setProperty('--sidebar-control-border', sidebarSurface.controlBorder);
  root.style.setProperty('--sidebar-brand-logo-bg', sidebarSurface.brandLogoBg);
  root.style.setProperty('--sidebar-text', sidebarSurface.text);
  root.style.setProperty('--sidebar-text-muted', sidebarSurface.textMuted);
  root.style.setProperty('--sidebar-text-active', sidebarSurface.textActive);
  root.style.setProperty('--sidebar-hover', sidebarSurface.hover);
  root.setAttribute('data-sidebar-variant', getSidebarVariant(colorScheme));

  root.style.setProperty('--maveshi-form-control-height', `${tokens.controlHeight}px`);
  root.style.setProperty('--maveshi-form-control-height-lg', `${tokens.controlHeightLG}px`);
  root.style.setProperty('--maveshi-form-control-height-sm', `${tokens.controlHeightSM}px`);
}
